import React from 'react';
import { Box, Typography } from '@mui/material';
import { SelectWrapper } from '../../../components/common/InputDropdown';
import { SelectMenuItem } from '../Header/Header.styled';
import { DataHeading } from '../Charts.styled';
import { ReactComponent as CheckIcon } from '../../../assets/icons/base/check.svg';
import { AvailableFilters, PickedFilters } from '../Charts.types';
import HeatmapGoogle from './HeatmapGoogle';
import { ReadsHeatWrapper } from './HeatmapTab.styled';

type HeatmapTabType = {
  type: 'all' | 'reads' | 'alerts';
  heatmapDataReads: google.maps.visualization.WeightedLocation[];
  heatmapDataAlerts: google.maps.visualization.WeightedLocation[];
  availableFilters: AvailableFilters;
  pickedFilters: PickedFilters;
  setPickedFilters: React.Dispatch<React.SetStateAction<PickedFilters>>;
  loading: boolean;
};

const HeatmapTab = (props: HeatmapTabType) => {
  const {
    type,
    heatmapDataReads, availableFilters, pickedFilters,
    setPickedFilters, heatmapDataAlerts, loading,
  } = props;

  return (
    <>
      {(type === 'all' || type === 'reads') && (
        <Box>
          <DataHeading>
            <Typography variant="txl" fontWeight="600">
              Reads over time
            </Typography>
            <Box />
          </DataHeading>
          <ReadsHeatWrapper>
            <HeatmapGoogle
              id="reads"
              darkModeMap
              enableSattelite
              heatmapData={heatmapDataReads}
              loading={loading}
            />
          </ReadsHeatWrapper>
        </Box>
      )}
      {(type === 'all' || type === 'alerts') && (
        <Box>
          <DataHeading>
            <Typography variant="txl" fontWeight="600">
              Alerts over time
            </Typography>
            <Box display="flex" gap="16px">
              <Box width="209px">
                <SelectWrapper
                  onChange={(e: any) => setPickedFilters({ ...pickedFilters, alerts: e.target.value })}
                  value={pickedFilters.alerts}
                  renderValue={(selected: any) => {
                    return <span>{selected.length} Alarm Classes</span>;
                  }}
                  multiple
                  displayEmpty
                >
                  {availableFilters.alerts.map((arm) => (
                    <SelectMenuItem key={arm.id} value={arm.id}>
                      {arm.name}
                      {pickedFilters.alerts.includes(arm.id) && <CheckIcon style={{ height: '20px', width: '20px' }} />}
                    </SelectMenuItem>
                  ))}
                </SelectWrapper>
              </Box>
            </Box>
          </DataHeading>
          <ReadsHeatWrapper>
            <HeatmapGoogle
              id="alerts"
              darkModeMap
              enableSattelite
              heatmapData={heatmapDataAlerts}
              loading={loading}
            />
          </ReadsHeatWrapper>
        </Box>
      )}
    </>
  );
};

export default HeatmapTab;
